<style lang="scss" scoped>
@import "~spinthatshit/src/variables";
@import "~spinthatshit/src/animations";
@import "~spinthatshit/src/loaders/loader01";

.spinner {
    @include loader01($size: 60px, $color: theme("colors.green"), $border-size: 2px);
}
</style>

<template>
    <div class="spinner"></div>
</template>

<script>
export default {};
</script>
